// POST to an SSE endpoint and dispatch parsed `data:` events to onEvent.
export async function streamChat(url, body, onEvent, signal) {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 90000);
  signal?.addEventListener("abort", () => ctrl.abort());
  try {
    return await run(url, body, onEvent, ctrl.signal);
  } finally {
    clearTimeout(timer);
  }
}

async function run(url, body, onEvent, signal) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`HTTP ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  let finished = false;
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) !== -1) {
      const chunk = buf.slice(0, i);
      buf = buf.slice(i + 2);
      const line = chunk.split("\n").find((l) => l.startsWith("data:"));
      if (!line) continue;
      const ev = JSON.parse(line.slice(5).trim());
      if (ev.type === "error") throw new Error(ev.detail || "stream error");
      if (ev.type === "done") finished = true;
      onEvent(ev);
    }
  }
  if (!finished) throw new Error("stream ended early");
}
